export class PcdRegulamentos {

    static pcdRegulamentosLista: PcdRegulamentos[] = [

        // LOCAL DOS ARQUIVOS - VM43 /var/www/html/wp-content/uploads/2023/05/
        { tipo: 'docLink', descricao: 'PCD - Regulamento', caminho: 'https://www.centrus.org.br/wp-content/uploads/2023/05/regulamento-pcd-08052023.pdf' }, // A partir de 08/05/2023
        { tipo: 'docLink', descricao: '09/12/2019 a 07/05/2023', caminho: 'https://www.centrus.org.br/wp-content/uploads/2020/08/07-regulamento_pcd_10122019.pdf' },
        { tipo: 'docLink', descricao: '08/07/2019 a 08/12/2019', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/06-reg_pcd_08072019_atu.pdf' },
        { tipo: 'docLink', descricao: '24/06/2015 a 07/07/2019', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/04-reg_pcd_24062015.pdf' },
        { tipo: 'docLink', descricao: '13/03/2014 a 23/06/2015', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/03-reg_pcd_13032014.pdf' },
        { tipo: 'docLink', descricao: '23/11/2006 a 12/03/2014', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/02-reg_pcd_23112006.pdf' },
        { tipo: 'docLink', descricao: '18/12/2002 a 22/11/2006', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/01-reg_pcd_18122002.pdf' }

    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {

    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/pcd-regulamentos.ts